import {createSlice} from '@reduxjs/toolkit'

export const timelineChartSlice = createSlice({
  name: 'timelineChart',
  initialState: {
    timelineType: '',
    uniqueConstituentIdentifier: '',
    timelineRefCategoryData: [],
    selectedProspect: {}
  },
  reducers: {
    setUniqueConstituentIdentifier: (state, action) => {
      state.uniqueConstituentIdentifier = action.payload
    },
    setTimelineType: (state, action) => {
      state.timelineType = action.payload
    },
    setTimelineRefCategoryData: (state, action) => {
      state.timelineRefCategoryData = action.payload
    },
    setSelectedProspect: (state, action) => {
      state.selectedProspect = action.payload
    }
  }
})

export const {setUniqueConstituentIdentifier, setTimelineType, setTimelineRefCategoryData, setSelectedProspect} =
  timelineChartSlice.actions

export default timelineChartSlice.reducer
